import { DateFormats } from '@55degrees/layout-r18';
import {
  DEFAULT_HISTORY_DATA_FETCH_LIMIT,
  DEFAULT_WEEK_STARTS_ON,
  HistoryDataFetchLimit,
  HISTORY_DATA_FETCH_LIMITS,
  LOCAL_STORAGE_DATEFORMAT_KEY,
  LOCAL_STORAGE_HISTORY_DATA_FETCH_LIMIT_KEY,
  LOCAL_STORAGE_LOCALE_KEY,
  LOCAL_STORAGE_WEEK_STARTS_ON_KEY,
  WeekStartsOnDay,
} from '../../config';
import { DateFormat, Locale } from '../../types/A3';
import { isValidWeekStartsOn } from '../../helper';
import { getUserProperties } from './getUserProperties';

function isValidDateFormat(dateFormat: string) {
  return DateFormats.indexOf(dateFormat) > -1;
}

function localeNoOldFormat(oldLocaleFormat: string): Locale {
  if (oldLocaleFormat === 'fr') return 'fr-FR';
  return 'en-US';
}

function getLocale() {
  const localeStorageLocale = localStorage.getItem(LOCAL_STORAGE_LOCALE_KEY);
  if (!localeStorageLocale) {
    return 'en-US';
  }
  if (['en', 'fr'].includes(localeStorageLocale)) {
    return localeNoOldFormat(localeStorageLocale);
  }

  return localeStorageLocale as Locale;
}

function getDateFormat() {
  const localStorageDateFormat = localStorage.getItem(LOCAL_STORAGE_DATEFORMAT_KEY);
  if (!isValidDateFormat(localStorageDateFormat)) {
    return DateFormats[0] as DateFormat;
  }

  return localStorageDateFormat as DateFormat;
}

function getWeekStartsOn(): WeekStartsOnDay {
  const localStorageWeekStartsOn = localStorage.getItem(LOCAL_STORAGE_WEEK_STARTS_ON_KEY);
  if (!isValidWeekStartsOn(localStorageWeekStartsOn)) {
    return DEFAULT_WEEK_STARTS_ON;
  }

  return Number(String(localStorageWeekStartsOn)) as WeekStartsOnDay;
}

function getHistoryFetchLimit() {
  const localStorageHistoryFetchLimit = localStorage.getItem(
    LOCAL_STORAGE_HISTORY_DATA_FETCH_LIMIT_KEY
  );

  if (
    localStorageHistoryFetchLimit &&
    HISTORY_DATA_FETCH_LIMITS.includes(
      Number(localStorageHistoryFetchLimit) as HistoryDataFetchLimit
    )
  ) {
    return Number(localStorageHistoryFetchLimit) as HistoryDataFetchLimit;
  }

  return DEFAULT_HISTORY_DATA_FETCH_LIMIT;
}

async function getAppSettings() {
  const locale = getLocale();
  const dateFormat = getDateFormat();
  const weekStartsOn = getWeekStartsOn();
  const historicalDataFetchLimit = getHistoryFetchLimit();
  const userProperties = await getUserProperties();

  return {
    dateFormat,
    lastLoadedDatasetId: userProperties?.lastLoadedDatasetId || '',
    locale,
    historicalDataFetchLimit,
    startupMode: userProperties?.startupMode || 'landing-page',
    weekStartsOn,
  };
}

export default getAppSettings;
